




































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as models from '@/api/models';
import * as api from '@/api';
import { State } from 'vuex-class';
import { IUserSession } from '@/store/modules/session';

@Component({})
export default class Today extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;

  listData = [];
  eventList = [];
  listQuery = {
    keyword: '',
    theme: '',
    publisher: '',
    source: '',
    city: '',
    eventCategoryId: undefined,
  };
  search() {
    this.fetchData();
  }
  async fetchData() {
    const data: any = await api.Yq.getToday_GET({
      eventCategoryId: '',
      keyword: this.listQuery.keyword,
      theme: this.listQuery.theme,
      publisher: this.listQuery.publisher,
      source: this.listQuery.source,
      city: this.listQuery.city,
    });
    this.listData = data.data;
  }

  async getEventType() {
    const data: any = await api.Yq.getAllCategories_GET();
    this.eventList = data.data;
  }

  mounted() {
    this.getEventType();
    this.fetchData();
  }
}
